import { themeGet } from '@styled-system/theme-get'
import { Container } from 'react-bootstrap'
import { useTranslation } from '~/i18n'
import { withTranslation } from 'react-i18next'
import Text from '~/components/UI/Text'
import Button from '../UI/Button'
import styled from 'styled-components'
import { layout } from 'styled-system'
import breakpoints from '~/components/UI/breakpoints'
import { ZINDEX } from '../../utils/constant'

const SocialBar = styled.div`
  background-color: ${themeGet('colors.light-1')};
  z-index: ${ZINDEX.HIGHEST};
  height: 72px;
  position: fixed;
  bottom: 0;
  transition: transform 0.2s;
  box-shadow: 0 -2px 10px 0 rgba(0, 85, 255, 0.1);
  background-image: linear-gradient(to bottom, #ffffff 0%, rgba(255, 255, 255, 0));
  ${layout}
  text-align: center;
  width: 100%;
  display: block;
  ${breakpoints.sm} {
    display: none;
  }
`

const ContainerRoot = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding: 18px 16px;
  background-image: linear-gradient(to top left, #0055ff, #0092ff);
  height: 100%;
`

if (typeof window !== 'undefined') {
  let lastY = window.scrollY
  let socialBar: any = null

  const onScroll = () => {
    const distanceToShow = 50
    if (!socialBar) {
      socialBar = document.getElementById('social-bar')
    }

    if (!socialBar) return

    if (window.scrollY > 0 && window.outerWidth < 576) {
      const newY = window.scrollY
      const distance = newY - lastY
      if (distance > distanceToShow) {
        socialBar.style.transform = `translateY(80px)`
        lastY = newY
      } else if (distance < -distanceToShow) {
        socialBar.style.transform = `translateY(0)`
        lastY = newY
      }
    }
  }
  window.addEventListener('scroll', onScroll)
}

const DownloadAppBanner = () => {
  const [t] = useTranslation()

  return (
    <SocialBar id="social-bar">
      <ContainerRoot>
        <HorizontalView>
          <LogoImage src="/images/logo.svg" />
          <AppDetailsView>
            <Text size={12} color="white">
              <b>{t`Infina`}</b> - {t`Đầu tư & Tích luỹ`}
            </Text>
            <img src="/images/stars.svg" />
            <Text size={12} color="#ffffff77">
              {t`(4.1K)`}
            </Text>
          </AppDetailsView>
          <ActionButton as="a" href="https://a.infina.link/A3yP/bottombar" target="_blank" rel="noopener noreferrer">
            <Text color="#0055ff" bold>{t`Tải App`}</Text>
          </ActionButton>
        </HorizontalView>
      </ContainerRoot>
    </SocialBar>
  )
}

export default withTranslation('common')(DownloadAppBanner)

//#region
const LogoImage = styled.img`
  flex-shrink: 1;
`

const HorizontalView = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const ActionButton = styled(Button)`
  background-color: white;
  border: none;
  flex-shrink: 1;
  border-radius: 4px;
  padding: 11px 10px;
  
  &:hover {
    text-decoration: none;
  }
`

const AppDetailsView = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 12px;
`
//#endregion
